export const SupportEmail = process.env.REACT_APP_SUPPORT_MAIL;
export const shipMatchEnabled = process.env.REACT_APP_SHIP_MATCH === "true";
export const customerEnabled = process.env.REACT_APP_CUSTOMER === "true";
export const branding = process.env.REACT_APP_ADMIN_APP_BRANDING;
export const enableCutOffDate = process.env.REACT_APP_ENABLE_CUT_OFF_DATE === "true";
export const canAddMultipleShippingOption = process.env.REACT_APP_CAN_ADD_MULTIPLE_SHIPPING_OPTION === "true";